// Simple Stripe product service for fetching product details from backend
class StripeProductService {
  async fetchProductDetails(productId) {
    try {
      // Fetch product details from backend API
      const response = await fetch(
        // `http://localhost:3001/v1/products/${productId}`,
        `https://skyhost.ai/get-stripe-product/${productId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.status}`);
      }

      const result = await response.json();

      if (!result.status || !result.data.success) {
        throw new Error(result.message || "Failed to fetch product details");
      }

      const { pricing } = result.data;
      const price = pricing[0]; // Get first active price

      if (!price) {
        throw new Error("No active price found for product");
      }

      // Convert from cents to dollars
      const priceInDollars = price.amount / 100;
      const flightCredits = 1; // Default to 1 credit per purchase

      return {
        id: 0,
        price: priceInDollars,
        flightCredits: flightCredits,
        perFlight: priceInDollars,
        savePercentage: null,
        productId: productId,
        priceId: price.id, // needed for subscription checkout
      };
    } catch (error) {
      console.error("Error fetching Stripe product:", error);
    }
  }
}

export const stripeProductService = new StripeProductService();
export default stripeProductService;
